import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  apiUrl:string;
 

  constructor(private httpClient: HttpClient) {
    // this.apiUrl = environment.apiUrl;
   }
  getUserImg(accID){
    // return this.httpClient.post(this.apiUrl+`users/fetch-image`,accID)
  }
}
